import React,{ Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";
import { handleFieldChange } from "../../../../Utils";

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            feed: null,
            subid: null
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(e) {
        e.preventDefault();

        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <Row>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.feeds}
                            label="Affid:"
                            name="feed"
                            onChange={this.handleFieldChange}
                            value={this.state.feed}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <FieldGroup
                            name="subid"
                            label="Subid:"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                        />
                    </Col>
                </Row>

                <Button type="submit" bsStyle="info" className="m-b-15" >Filter</Button>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/AdkBoosters/components/Filters/index.js